// common.proto — vocabulary shared by every other file in amrec.v1.
//
// These enums are the normalized target that every upstream source is mapped
// onto. AniList, MAL/Jikan, MangaDex and VNDB each use their own incompatible
// spellings for the same concepts ("MANGA" vs "manga" vs "Manga"; "FINISHED"
// vs "finished" vs "completed"); the source adapters own that translation so
// nothing downstream ever branches on which site a row came from.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file amrec/v1/common.proto (package amrec.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file amrec/v1/common.proto.
 */
export const file_amrec_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Title is one name for a work. A popular series easily has 20+ of these
 * across languages and sources, which is exactly why fuzzy search targets the
 * title table rather than a single canonical string on the work.
 *
 * @generated from message amrec.v1.Title
 */
export type Title = Message<"amrec.v1.Title"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: amrec.v1.TitleLanguage language = 2;
   */
  language: TitleLanguage;

  /**
   * BCP-47 tag when the source gives one (MangaDex titles are keyed by
   * language code). Empty when unknown.
   *
   * @generated from field: string locale = 3;
   */
  locale: string;

  /**
   * @generated from field: bool is_primary = 4;
   */
  isPrimary: boolean;
};

/**
 * Describes the message amrec.v1.Title.
 * Use `create(TitleSchema)` to create a new message.
 */
export const TitleSchema: GenMessage<Title> = /*@__PURE__*/
  messageDesc(file_amrec_v1_common, 0);

/**
 * FuzzyDate is a partial date. Upstream data is riddled with "1998, month
 * unknown" and "sometime in the 90s"; a Timestamp would force us to invent
 * precision we don't have. Zero in any field means "unknown".
 *
 * @generated from message amrec.v1.FuzzyDate
 */
export type FuzzyDate = Message<"amrec.v1.FuzzyDate"> & {
  /**
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * @generated from field: int32 month = 2;
   */
  month: number;

  /**
   * @generated from field: int32 day = 3;
   */
  day: number;
};

/**
 * Describes the message amrec.v1.FuzzyDate.
 * Use `create(FuzzyDateSchema)` to create a new message.
 */
export const FuzzyDateSchema: GenMessage<FuzzyDate> = /*@__PURE__*/
  messageDesc(file_amrec_v1_common, 1);

/**
 * ExternalRef ties a canonical work back to one upstream record. The pair
 * (source, source_id) is unique per work and is what the entity resolver
 * writes when it decides two records are the same thing.
 *
 * @generated from message amrec.v1.ExternalRef
 */
export type ExternalRef = Message<"amrec.v1.ExternalRef"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * @generated from field: string source_id = 2;
   */
  sourceId: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * Describes the message amrec.v1.ExternalRef.
 * Use `create(ExternalRefSchema)` to create a new message.
 */
export const ExternalRefSchema: GenMessage<ExternalRef> = /*@__PURE__*/
  messageDesc(file_amrec_v1_common, 2);

/**
 * SourceStats is one provider's popularity/quality signal for a work,
 * snapshotted at a point in time. Kept per-source rather than averaged: MAL's
 * score distribution is not comparable to AniList's, and the recommender wants
 * the raw signals so it can weight them itself.
 *
 * @generated from message amrec.v1.SourceStats
 */
export type SourceStats = Message<"amrec.v1.SourceStats"> & {
  /**
   * @generated from field: amrec.v1.Source source = 1;
   */
  source: Source;

  /**
   * Normalized to 0-100 regardless of the upstream scale.
   *
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * @generated from field: int32 score_count = 3;
   */
  scoreCount: number;

  /**
   * @generated from field: int32 popularity_rank = 4;
   */
  popularityRank: number;

  /**
   * @generated from field: int32 favorites = 5;
   */
  favorites: number;

  /**
   * @generated from field: google.protobuf.Timestamp observed_at = 6;
   */
  observedAt?: Timestamp | undefined;
};

/**
 * Describes the message amrec.v1.SourceStats.
 * Use `create(SourceStatsSchema)` to create a new message.
 */
export const SourceStatsSchema: GenMessage<SourceStats> = /*@__PURE__*/
  messageDesc(file_amrec_v1_common, 3);

/**
 * Source identifies an upstream provider. Persisted as a string in
 * `work_sources.source`, so the enum names are load-bearing — renaming one is
 * a data migration, not a refactor.
 *
 * @generated from enum amrec.v1.Source
 */
export enum Source {
  /**
   * @generated from enum value: SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SOURCE_ANILIST = 1;
   */
  ANILIST = 1,

  /**
   * via Jikan v4; MAL-official would still be SOURCE_MAL
   *
   * @generated from enum value: SOURCE_MAL = 2;
   */
  MAL = 2,

  /**
   * @generated from enum value: SOURCE_MANGADEX = 3;
   */
  MANGADEX = 3,

  /**
   * @generated from enum value: SOURCE_VNDB = 4;
   */
  VNDB = 4,

  /**
   * Not a crawlable API — the manami anime-offline-database weekly JSON dump.
   * It contributes ID mappings only, never title metadata, so it can seed the
   * resolver without competing with real sources for field precedence.
   *
   * @generated from enum value: SOURCE_MANAMI = 5;
   */
  MANAMI = 5,
}

/**
 * Describes the enum amrec.v1.Source.
 */
export const SourceSchema: GenEnum<Source> = /*@__PURE__*/
  enumDesc(file_amrec_v1_common, 0);

/**
 * WorkKind is the coarse medium. This is what a user means by "anime or
 * manga", and it partitions the catalog for search filters.
 *
 * Deliberately separate from MediaFormat: a work is a MANGA whether it ships
 * as a serialized manga, a one-shot, or a doujinshi. Kind answers "what shelf
 * does this live on", format answers "what shape is it".
 *
 * @generated from enum amrec.v1.WorkKind
 */
export enum WorkKind {
  /**
   * @generated from enum value: WORK_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORK_KIND_ANIME = 1;
   */
  ANIME = 1,

  /**
   * @generated from enum value: WORK_KIND_MANGA = 2;
   */
  MANGA = 2,

  /**
   * @generated from enum value: WORK_KIND_LIGHT_NOVEL = 3;
   */
  LIGHT_NOVEL = 3,

  /**
   * @generated from enum value: WORK_KIND_VISUAL_NOVEL = 4;
   */
  VISUAL_NOVEL = 4,
}

/**
 * Describes the enum amrec.v1.WorkKind.
 */
export const WorkKindSchema: GenEnum<WorkKind> = /*@__PURE__*/
  enumDesc(file_amrec_v1_common, 1);

/**
 * MediaFormat is the fine-grained shape within a kind.
 *
 * @generated from enum amrec.v1.MediaFormat
 */
export enum MediaFormat {
  /**
   * @generated from enum value: MEDIA_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEDIA_FORMAT_TV = 1;
   */
  TV = 1,

  /**
   * @generated from enum value: MEDIA_FORMAT_TV_SHORT = 2;
   */
  TV_SHORT = 2,

  /**
   * @generated from enum value: MEDIA_FORMAT_MOVIE = 3;
   */
  MOVIE = 3,

  /**
   * @generated from enum value: MEDIA_FORMAT_SPECIAL = 4;
   */
  SPECIAL = 4,

  /**
   * @generated from enum value: MEDIA_FORMAT_OVA = 5;
   */
  OVA = 5,

  /**
   * @generated from enum value: MEDIA_FORMAT_ONA = 6;
   */
  ONA = 6,

  /**
   * @generated from enum value: MEDIA_FORMAT_MUSIC = 7;
   */
  MUSIC = 7,

  /**
   * @generated from enum value: MEDIA_FORMAT_MANGA = 8;
   */
  MANGA = 8,

  /**
   * @generated from enum value: MEDIA_FORMAT_NOVEL = 9;
   */
  NOVEL = 9,

  /**
   * @generated from enum value: MEDIA_FORMAT_ONE_SHOT = 10;
   */
  ONE_SHOT = 10,

  /**
   * @generated from enum value: MEDIA_FORMAT_DOUJINSHI = 11;
   */
  DOUJINSHI = 11,

  /**
   * @generated from enum value: MEDIA_FORMAT_MANHWA = 12;
   */
  MANHWA = 12,

  /**
   * @generated from enum value: MEDIA_FORMAT_MANHUA = 13;
   */
  MANHUA = 13,

  /**
   * visual novels
   *
   * @generated from enum value: MEDIA_FORMAT_GAME = 14;
   */
  GAME = 14,
}

/**
 * Describes the enum amrec.v1.MediaFormat.
 */
export const MediaFormatSchema: GenEnum<MediaFormat> = /*@__PURE__*/
  enumDesc(file_amrec_v1_common, 2);

/**
 * @generated from enum amrec.v1.ReleaseStatus
 */
export enum ReleaseStatus {
  /**
   * @generated from enum value: RELEASE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RELEASE_STATUS_FINISHED = 1;
   */
  FINISHED = 1,

  /**
   * @generated from enum value: RELEASE_STATUS_RELEASING = 2;
   */
  RELEASING = 2,

  /**
   * @generated from enum value: RELEASE_STATUS_NOT_YET = 3;
   */
  NOT_YET = 3,

  /**
   * @generated from enum value: RELEASE_STATUS_CANCELLED = 4;
   */
  CANCELLED = 4,

  /**
   * @generated from enum value: RELEASE_STATUS_HIATUS = 5;
   */
  HIATUS = 5,
}

/**
 * Describes the enum amrec.v1.ReleaseStatus.
 */
export const ReleaseStatusSchema: GenEnum<ReleaseStatus> = /*@__PURE__*/
  enumDesc(file_amrec_v1_common, 3);

/**
 * ContentRating collapses four incompatible upstream schemes onto one ladder:
 * AniList's boolean `isAdult`, MAL's rating strings (G/PG/PG-13/R/R+/Rx),
 * MangaDex's contentRating (safe/suggestive/erotica/pornographic), and VNDB's
 * sexual/violence levels.
 *
 * The catalog stores NSFW titles (that was an explicit scope decision), so
 * this field is the sole gate — every query path defaults to filtering at
 * SUGGESTIVE unless a request opts in. Mapping is lossy and deliberately
 * conservative: when two sources disagree, the resolver keeps the stricter.
 *
 * @generated from enum amrec.v1.ContentRating
 */
export enum ContentRating {
  /**
   * @generated from enum value: CONTENT_RATING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTENT_RATING_SAFE = 1;
   */
  SAFE = 1,

  /**
   * @generated from enum value: CONTENT_RATING_SUGGESTIVE = 2;
   */
  SUGGESTIVE = 2,

  /**
   * @generated from enum value: CONTENT_RATING_EROTICA = 3;
   */
  EROTICA = 3,

  /**
   * @generated from enum value: CONTENT_RATING_EXPLICIT = 4;
   */
  EXPLICIT = 4,
}

/**
 * Describes the enum amrec.v1.ContentRating.
 */
export const ContentRatingSchema: GenEnum<ContentRating> = /*@__PURE__*/
  enumDesc(file_amrec_v1_common, 4);

/**
 * TitleLanguage tags each row in `work_titles`. Fuzzy search matches against
 * every variant regardless of language, but display prefers ROMAJI/ENGLISH and
 * ranking uses the language to break ties.
 *
 * @generated from enum amrec.v1.TitleLanguage
 */
export enum TitleLanguage {
  /**
   * @generated from enum value: TITLE_LANGUAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TITLE_LANGUAGE_ROMAJI = 1;
   */
  ROMAJI = 1,

  /**
   * @generated from enum value: TITLE_LANGUAGE_ENGLISH = 2;
   */
  ENGLISH = 2,

  /**
   * Japanese/Korean/Chinese original script
   *
   * @generated from enum value: TITLE_LANGUAGE_NATIVE = 3;
   */
  NATIVE = 3,

  /**
   * alternate spellings, abbreviations, fan names
   *
   * @generated from enum value: TITLE_LANGUAGE_SYNONYM = 4;
   */
  SYNONYM = 4,
}

/**
 * Describes the enum amrec.v1.TitleLanguage.
 */
export const TitleLanguageSchema: GenEnum<TitleLanguage> = /*@__PURE__*/
  enumDesc(file_amrec_v1_common, 5);

